import { get as serverGet, put } from 'Server';
import { urls } from 'Reducers/notifications';
import { isEmpty } from 'Helpers/objects';
import {
    isGetNotificationsFetching,
    notificationsSelector,
    notificationsMetaSelector
} from 'Selectors/notifications';
import { NOTIFICATIONS_LIMIT } from 'Constants/notifications';
import toggleUnreadNotifications from 'Actions/toggleUnreadNotifications';

const getNotifications = () => (dispatch, getState, { get }) => {
    const state = getState();
    const params = {
        limit: NOTIFICATIONS_LIMIT
    };

    if (isGetNotificationsFetching(state)) {
        return Promise.resolve();
    }

    return dispatch(get(urls.getNotifications, 'NOTIFICATIONS', params)).then(res => {
        if (res.ok && res.data.meta.new > 0) {
            dispatch(toggleUnreadNotifications(true));
        }
    });
};

const loadMoreNotifications = () => (dispatch, getState) => {
    const state = getState();
    const notifications = notificationsSelector(state);
    const metadata = notificationsMetaSelector(state);
    const lastNotification = notifications[notifications.length - 1];
    const params = {
        limit: NOTIFICATIONS_LIMIT
    };

    if (metadata.total > notifications.lenght || isGetNotificationsFetching(state)) {
        return Promise.resolve();
    }

    params.before = lastNotification.created;

    return dispatch(serverGet(urls.getNotifications, 'APPEND_NOTIFICATIONS', params));
};

const updateNotifications = params => dispatch => {
    if (isEmpty(params)) {
        return Promise.reject();
    }

    return dispatch(put(urls.updateNotifications, 'UPDATE_NOTIFICATIONS', params));
};

export {
    getNotifications,
    loadMoreNotifications,
    updateNotifications
};
